import React, { useEffect, useState } from 'react';
import { Phone, Menu, X, Wrench } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Resources',
    href: '#resources'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 backdrop-blur-sm py-4'}`} data-id="element-170">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
        <div className="flex justify-between items-center" data-id="element-172">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3 group" data-id="element-173">
            <div className="bg-brand-navy p-2 rounded-md flex items-center justify-center group-hover:bg-brand-dark transition-colors" data-id="element-174">
              <Wrench className="w-6 h-6 text-white" data-id="element-175" />
            </div>
            <div className="flex flex-col" data-id="element-176">
              <span className="font-display font-bold text-2xl leading-none text-brand-navy uppercase tracking-wide" data-id="element-177">
                Done Right
              </span>
              <span className="text-[10px] font-bold text-brand-red uppercase tracking-widest" data-id="element-178">
                Plumbing Inc. • Est 1990
              </span>
            </div>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-179">
            <ul className="flex items-center gap-6" data-id="element-180">
              {navLinks.map(link => <li key={link.name} data-id="element-181">
                  <a href={link.href} className="text-sm font-semibold text-gray-700 hover:text-brand-red transition-colors uppercase tracking-wider" data-id="element-182">
                    {link.name}
                  </a>
                </li>)}
            </ul>
            <a href="tel:8185550190" className="flex items-center gap-2 bg-brand-red hover:bg-brand-redDark text-white px-5 py-2.5 rounded-md font-semibold transition-colors shadow-sm" data-id="element-183">
              <Phone className="w-4 h-4" data-id="element-184" />
              <span data-id="element-185">(818) 555-0190</span>
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden p-2 text-brand-navy" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-186">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-187" /> : <Menu className="w-6 h-6" data-id="element-188" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-189">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-190">
            <div className="px-4 pt-2 pb-6 space-y-1 shadow-inner" data-id="element-191">
              {navLinks.map(link => <a key={link.name} href={link.href} className="block px-3 py-3 text-base font-semibold text-gray-800 hover:bg-brand-gray hover:text-brand-red rounded-md uppercase tracking-wide" onClick={() => setMobileMenuOpen(false)} data-id="element-192">
                  {link.name}
                </a>)}
              <div className="pt-4 px-3" data-id="element-193">
                <a href="tel:8185550190" className="flex items-center justify-center gap-2 bg-brand-red text-white px-5 py-3 rounded-md font-bold w-full" data-id="element-194">
                  <Phone className="w-5 h-5" data-id="element-195" />
                  <span data-id="element-196">Call (818) 555-0190</span>
                </a>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}